// 導覽演示視頻配置
// 用戶可以在此處添加 YouTube 視頻 URL

export const VIDEO_URLS = {
  // 步驟 0: 儀表板演示
  0: 'https://www.youtube.com/embed/VFSN1FWcUBs',
  
  // 步驟 1: 訊息模版管理演示
  1: 'https://www.youtube.com/embed/AdTA2UySMFY',
  
  // 步驟 2: 聯絡人管理演示
  2: 'https://www.youtube.com/embed/3OGkTmkz-Is',
  
  // 步驟 3: 數據集管理演示
  3: 'https://www.youtube.com/embed/mhJnxhRBGK4', // 例如: 'https://www.youtube.com/embed/VIDEO_ID'
  
  // 步驟 4: 表單管理演示
  4: 'https://www.youtube.com/embed/4yr6y_NhpF4', // 例如: 'https://www.youtube.com/embed/VIDEO_ID'
  
  // 步驟 5: 工作流程設計演示
  5: 'https://www.youtube.com/embed/lH82AY7vjP0'  // 例如: 'https://www.youtube.com/embed/VIDEO_ID'
};

// 使用說明：
// 1. 將您的 YouTube 視頻 URL 替換到對應的位置
// 2. 確保 URL 格式為 YouTube 嵌入格式：https://www.youtube.com/embed/VIDEO_ID
// 3. 可以通過 YouTube 視頻頁面的「分享」→「嵌入」選項獲取正確的 URL
// 4. 保存文件後，導覽系統會自動載入視頻

export default VIDEO_URLS;
